<template>
  <span class="u-message">
    <Poptip placement="bottom-end">
      <template #title>
        <Dropdown @on-click="handleClick">
          <a href="javascript:void(0)">
            {{ isAll ? "全部消息" : "未读消息" }}
            <Icon type="ios-arrow-down"></Icon>
          </a>
          <DropdownMenu slot="list">
            <DropdownItem name="1">全部消息</DropdownItem>
            <DropdownItem name="0">未读消息</DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </template>
      <template #content>
        <div class="content">
          <div
            @click="goToDetail(item)"
            class="item fjcsb"
            :class="{ active: !item.readType }"
            v-for="(item, index) in listFilter"
            :key="index"
          >
            <div>
              <Icon type="ios-notifications" />
              <span>FAQ反馈问题已回复，快点击查看吧！</span>
            </div>
            <span class="time">{{ item.answerTime }}</span>
          </div>
          <empty v-if="!listFilter.length" />
        </div>
      </template>
      <Badge :count="newNewsSize">
        <Icon type="ios-notifications" />
      </Badge>
    </Poptip>
    <feedbackRecord ref="feedbackRecord" />
  </span>
</template>

<script>
import request from "@/utils/request";
export default {
  data() {
    return {
      list: [],
      isAll: false,
    };
  },
  computed: {
    listFilter() {
      return this.isAll
        ? this.list
        : this.list.filter((item) => !item.readType);
    },
    newNewsSize() {
      return this.list.filter((item) => !item.readType).length;
    },
  },
  methods: {
    goToDetail(item) {
      this.$refs.feedbackRecord.open(item);
      request
        .post("/saasbaihui/readFAQMsg", {
          faqId: item.faqId,
        })
        .then((res) => {
          item.readType = 1;
        });
    },
    getData() {
      request.post("/saasbaihui/getFAQMsg").then((res) => {
        this.list = res.result;
      });
    },
    handleClick(val) {
      this.isAll = val == "1" ? true : false;
    },
  },
  mounted() {
    this.getData();
    this.$bus.on("FAQMsg", this.getData);
  },
};
</script>

<style lang="scss" scoped>
.u-message {
  font-size: 13px;
  .ivu-icon {
    font-size: 20px;
    color: #fff;
  }
  :deep {
    .ivu-poptip-popper {
      width: 400px;
      color: #333;
      .ivu-icon {
        color: #333;
      }
      .ivu-poptip-title {
        text-align: right;
        font-size: 13px;
      }
      .content {
        min-height: 200px;
        max-height: 500px;
        overflow-y: auto;
        .item {
          padding: 5px 0;
          color: #aaa;
          cursor: pointer;
          .time {
            color: #aaa;
          }
          .ivu-icon {
            opacity: 0.6;
          }
          &.active {
            color: #333;
            .ivu-icon {
              opacity: 1;
            }
          }
        }
      }
    }
    .ivu-badge-count {
      right: 5px;
      top: 2px;
    }
    .ivu-dropdown {
      a {
        color: #000;
      }
      .ivu-dropdown-item {
        text-align: center;
        padding: 5px 0;
      }
    }
  }
}
</style>